module.exports = __webpack_public_path__ + "static/media/resource-11.ce60dbdf.png";